import { Container, Graphics, Text } from 'pixi.js';
import { woodGradient } from './BoardPanel';
import { displayStyle } from './ui';

/**
 * A carved title plate. Its origin is its centre, so put it on a board's
 * top edge (`plaque.y = board.y`) and half of it rides above the board, as
 * the panel's and the run bar's titles do.
 */
export class TitlePlaque extends Container {
  private readonly plate = new Graphics();
  private readonly caption: Text;

  /** `padX` is the wood each side of the words (smaller for a tag). */
  constructor(title: string, size = 15, private readonly padX = 15) {
    super();
    this.caption = new Text({ text: title, style: displayStyle(size) });
    this.caption.anchor.set(0.5);
    this.addChild(this.plate, this.caption);
    this.redraw();
  }

  setTitle(title: string): void {
    if (this.caption.text === title) return;
    this.caption.text = title;
    this.redraw();
  }

  /** The title as shown. */
  get text(): string {
    return this.caption.text;
  }

  /** The plate's height, for leaving room under it. */
  get plateHeight(): number {
    return Math.round(this.caption.height + 6);
  }

  private redraw(): void {
    const w = Math.round(this.caption.width + this.padX * 2);
    const h = this.plateHeight;
    // No drop shadow under the plate, as with the boards (producer 2026-11-03).
    this.plate
      .clear()
      .roundRect(-w / 2, -h / 2, w, h, 8)
      .fill(woodGradient())
      .stroke({ color: 0xd9a441, width: 1.5 });
    this.caption.y = 1;
  }
}
